import React from "react";
import styled from "styled-components";
import FancyImg from "./fancyImg";
import { Column, Title, Content } from "../globals/style";

const Wrapper = styled.div`
  background: ${(props) => (props.inverse ? "#1e1d22" : "#efefef")};
  color: ${(props) => (props.inverse ? "#efefef" : "#1e1d22")};
  min-height: calc(100vh - 80px);
  width: 100%;
`;
const InsideWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1920px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
`;
const ColumnInline = styled(Column)`
  align-items: center;
  padding: 2em;
  flex-basis: 50%;
  @media screen and (max-width: 991px) {
    padding: 2em 1.5em;
    flex-basis: 100%;
  }
`;
const ContentHolder = styled.div`
  width: 80%;
  @media screen and (max-width: 991px) {
    width: 100%;
  }
`;
const contentField = ({ data }) => (
  <Wrapper>
    <InsideWrapper>
      <Column style={{ padding: 0, flex: "1 0 auto" }}>
        <FancyImg
          alt={data.Title}
          src={data.ContentImage.childImageSharp.fluid}
        />
      </Column>
      <ColumnInline>
        <ContentHolder>
          <Title>{data.Title}</Title>
          <Content>{data.Content}</Content>
        </ContentHolder>
      </ColumnInline>
    </InsideWrapper>
  </Wrapper>
);
export default contentField;
